import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../components/MaterialTypography";
import { Box, Dialog } from "@mui/material";
import MaterialButton from "../../components/MaterialButton";
import colors from "../../assest/theme/base/colors";
import CloseIcon from "@mui/icons-material/Close";
import MaterialInput from "../../components/MaterialInput";

function FilterDialog({
  open,
  onClose,
  filterSubmit,
  filterData,
  setFilterData,
}) {
  const handleReportsChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...filterData };
    if (event?.target === undefined && selectEvent) {
      if (
        selectEvent.name === "status" ||
        selectEvent.name === "exportType" ||
        selectEvent.name === "position"
      ) {
        const lengthRegex = new RegExp("^.{1,50}$");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "fromDate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "toDate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setFilterData(formState);
  };

  const isFormValid = () => {
    return (
      filterData.fromDateStatus === "success" &&
      filterData.toDateStatus === "success"
    );
  };

  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          width: "600px", // Set your desired width
          maxWidth: "none", // Prevent it from limiting the width to default sizes
          p: 2,
          borderRadius: "25px",
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "flex-end", px: 2 }}>
        <CloseIcon
          onClick={onClose}
          fontSize="50px"
          sx={{ color: colors.black.main, fontSize: "30px", cursor: "pointer" }}
        />
      </Box>
      <Grid container spacing={4} p={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            From Date
            <span style={{ marginLeft: "2px", color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            name="fromDate"
            type="date"
            value={filterData.fromDate}
            onChange={handleReportsChange}
            error={filterData.fromDateStatus === "error" ? true : false}
            success={filterData.fromDateStatus === "success" ? true : false}
            inputProps={{
              max: new Date().toISOString().split("T")[0], // max today
            }}
          />
          {filterData.fromDateStatus === "error" && (
            <MaterialTypography
              variant="caption"
              color="error"
              sx={{ mt: 0.5, display: "block" }}
            >
              From Date Should be DD-MM-YYYY.
            </MaterialTypography>
          )}
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            To Date
            <span style={{ marginLeft: "2px", color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            name="toDate"
            type="date"
            value={filterData.toDate}
            onChange={handleReportsChange}
            error={filterData.toDateStatus === "error" ? true : false}
            success={filterData.toDateStatus === "success" ? true : false}
            inputProps={{
              max: new Date().toISOString().split("T")[0], // max today
              min: filterData.fromDate || undefined, // min fromDate
            }}
          />
          {filterData.toDateStatus === "error" && (
            <MaterialTypography
              variant="caption"
              color="error"
              sx={{ mt: 0.5, display: "block" }}
            >
              To Date Should be DD-MM-YYYY.
            </MaterialTypography>
          )}
        </Grid>

        <Grid size={{ xs: 12, md: 12 }}>
          <Box display="flex" justifyContent="center" gap={5} mt={3.4}>
            <MaterialButton
              variant="contained"
              sx={{
                background: colors.buttonColor,
                color: "#fff",
                textTransform: "capitalize",
              }}
              disabled={!isFormValid()}
              onClick={filterSubmit}
            >
              Submit
            </MaterialButton>
            <MaterialButton onClick={onClose} variant="outlined" color="error">
              Cancel
            </MaterialButton>
          </Box>
        </Grid>
      </Grid>
    </Dialog>
  );
}

export default FilterDialog;
